import { render, staticRenderFns } from "./baseSchedule.vue?vue&type=template&id=07d0627a&scoped=true&"
import script from "./baseSchedule.vue?vue&type=script&lang=ts&"
export * from "./baseSchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d0627a",
  null
  
)

export default component.exports